// 配置路由相关的信息
import VueRouter from 'vue-router'
import Vue from 'vue'
 
import Maker from '../pages/maker'
import Vip from '../pages/vip'
import Help from '../pages/help'
import Personal from '../pages/personal'

import CreateAudio from '../pages/maker-sub/create-audio'
import QualityTemplate from '../pages/maker-sub/quality-template'
import MyAudio from '../pages/maker-sub/my-audio'
import MyDraft from '../pages/maker-sub/my-draft'

import PersonalVip from '../pages/personal-sub/vip'
import PersonalList from '../pages/personal-sub/list'
 
// 1.通过Vue.use(插件), 安装插件
Vue.use(VueRouter)
 
// 2.创建VueRouter对象
const routes = [
  {
    path: '/maker',
    component: Maker,
    redirect: '/maker/create',
    children: [
      {
        path: 'create',
        component: CreateAudio,
      },
      {
        path: 'template',
        component: QualityTemplate,
      },
      {
        path: 'audio',
        component: MyAudio,
      },
      {
        path: 'draft',
        component: MyDraft,
      },
    ]
  },
  {
    path: '/vip',
    component: Vip
  },
  {
    path: '/help',
    component: Help
  },
  {
    path: '/personal',
    component: Personal,
    children: [
      {
        path: 'vip',
        component: PersonalVip,
      },
      {
        path: 'list',
        component: PersonalList,
      },
    ]
  },
  { path: '*', redirect: '/maker/create', hidden: true }
  // {
  //   path: '/standard',
  //   name: 'standard',
  //   component: resolve => require(['../pages/c'], resolve),
  //   children: [
  //     {
  //       path: 'a',
  //       component: resolve => require(['../pages/a'], resolve),
  //     },
  //     {
  //       path: 'b',
  //       component: resolve => require(['../pages/b'], resolve),
  //     },
  //   ]
  // },
]
const router = new VueRouter({
  // 配置路由和组件之间的应用关系
  routes,
  mode: 'history',
  linkActiveClass: 'active',
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})
const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
// 3.将router对象传入到Vue实例
export default router
 